import { render, staticRenderFns } from "./dropdownMenuItem.vue?vue&type=template&id=6689327c&scoped=true&"
import script from "./dropdownMenuItem.vue?vue&type=script&lang=js&"
export * from "./dropdownMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./dropdownMenuItem.vue?vue&type=style&index=0&id=6689327c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689327c",
  null
  
)

export default component.exports